import _ from 'underscore'
import axios from 'axios'
import store from '../state/store'

store.on('search', function(search = '') {
  const parsed_search = (search || '').trim()

  if (parsed_search.length < 3) {
    store.get().search.set({results: [], loading: false})
    return
  }

  store.get().search.set({loading: true})

  const params = {
    q: parsed_search
  }

  axios.get("/api/sales/searches", {params: params})
  .then(function(response) {
    store.get().search.set({results: response.data.results})
  })
  .catch(function(error) {
    handleError(error)
  })
  .then(function() {
    store.get().search.set({loading: false})
  })
})